import React from "react";
import Skeleton from "../../ui/Skeleton";
import { LIST_GRID_CLASS } from "./StudentManagementModalComponents";

export function AvaliationTabSkeleton() {
  return (
    <div className="space-y-3 sm:space-y-4 md:space-y-6">
      <div className="flex flex-col gap-2 sm:gap-3 md:gap-4">
        <div>
          <Skeleton className="h-6 sm:h-7 md:h-8 w-48 sm:w-56 md:w-64 mb-2" />
          <Skeleton className="h-4 sm:h-5 w-64 sm:w-72 md:w-80" />
        </div>
        <Skeleton className="min-h-[48px] w-full rounded-xl sm:min-h-0 sm:h-10 sm:w-40 sm:rounded-xl" />
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="rounded-xl border border-stroke bg-white p-3 shadow-sm dark:border-strokedark dark:bg-boxdark sm:p-4 md:p-5 sm:rounded-2xl"
          >
            <div className="mb-3 sm:mb-4">
              <Skeleton className="h-5 sm:h-6 w-32 sm:w-40 mb-2" />
              <Skeleton className="h-4 w-24 sm:w-28" />
            </div>
            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-20 sm:w-24" />
                <Skeleton className="h-4 w-16 sm:w-20" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-24 sm:w-28" />
                <Skeleton className="h-4 w-16 sm:w-20" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-20 sm:w-24" />
                <Skeleton className="h-4 w-16 sm:w-20" />
              </div>
            </div>
            <div className="mt-4 flex gap-2 sm:gap-3">
              <Skeleton className="min-h-[44px] flex-1 rounded-lg sm:min-h-0 sm:h-9 sm:rounded-xl" />
              <Skeleton className="min-h-[44px] min-w-[44px] rounded-lg sm:min-h-0 sm:min-w-0 sm:h-9 sm:w-9 sm:rounded-xl" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function WorkoutTabSkeleton() {
  return (
    <div className="space-y-2 sm:space-y-4 md:space-y-6">
      <div className="flex flex-col gap-2 sm:gap-3 md:gap-4">
        <div>
          <Skeleton className="h-6 sm:h-7 md:h-8 w-48 sm:w-56 md:w-64 mb-2" />
          <Skeleton className="h-4 sm:h-5 w-64 sm:w-72 md:w-80" />
        </div>
        <Skeleton className="min-h-[48px] w-full rounded-xl sm:min-h-0 sm:h-10 sm:w-40 sm:rounded-xl" />
      </div>
      <div className={LIST_GRID_CLASS}>
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="rounded-xl border border-stroke bg-white p-3 shadow-sm dark:border-strokedark dark:bg-boxdark sm:p-4 md:p-5 sm:rounded-2xl"
          >
            <div className="mb-3 sm:mb-4">
              <Skeleton className="h-6 sm:h-7 w-3/4 sm:w-2/3 mb-2" />
              <Skeleton className="h-4 w-1/2 sm:w-1/3" />
            </div>
            <div className="space-y-2 sm:space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-4/6" />
            </div>
            <div className="mt-4 flex gap-2 sm:gap-3">
              <Skeleton className="min-h-[44px] flex-1 rounded-lg sm:min-h-0 sm:h-9 sm:rounded-xl" />
              <Skeleton className="min-h-[44px] min-w-[44px] rounded-lg sm:min-h-0 sm:min-w-0 sm:h-9 sm:w-9 sm:rounded-xl" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ProfileTabSkeleton() {
  return (
    <div className="space-y-3 sm:space-y-4 md:space-y-6">
      <div className="rounded-xl border border-stroke bg-white p-3 shadow-sm dark:border-strokedark dark:bg-boxdark sm:p-4 md:p-6 sm:rounded-2xl">
        <div className="mb-4 sm:mb-6">
          <Skeleton className="h-7 sm:h-8 w-40 sm:w-48 mb-3" />
          <Skeleton className="h-4 w-64 sm:w-80" />
        </div>
        <div className="space-y-4 sm:space-y-5">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="flex items-center gap-3 sm:gap-4">
              <Skeleton className="h-10 w-10 sm:h-12 sm:w-12 rounded-full flex-shrink-0" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-32 sm:w-40" />
                <Skeleton className="h-3 w-48 sm:w-56" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="rounded-xl border border-stroke bg-white p-3 shadow-sm dark:border-strokedark dark:bg-boxdark sm:p-4 md:p-6 sm:rounded-2xl">
        <Skeleton className="h-7 sm:h-8 w-40 sm:w-48 mb-4" />
        <div className="grid grid-cols-2 gap-2 sm:gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="space-y-2">
              <Skeleton className="h-4 w-20 sm:w-24" />
              <Skeleton className="h-6 w-full" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
